module.exports = __webpack_public_path__ + "img/code-tag.39c0db39.svg";